// import moment from "moment";

export const NewsChangelogElementRange = {
  translations: {
    20: 'lang.shared.twenty',
    50: 'lang.shared.fifty',
    100: 'lang.shared.all'
  },
  enum: {
    TWENTY: 20,
    FIFTY: 50,
    ALL: 100
  }
};

export const NewsChangelogElementTypes = {
  translations: {
    0: 'lang.layout.dashboard',
    1: 'lang.layout.publications',
    2: 'lang.layout.listManagement',
    3: 'lang.layout.ratings',
    4: 'lang.layout.replacementList',
    5: 'lang.shared.configuration',
    6: 'lang.shared.otherNews'
  },
  enum: {
    HOMEPAGE: 0,
    PUBLICATIONS: 1,
    ADMITTED_AND_EXCLUDED: 2,
    RATINGS: 3,
    REPLACEMENT_LISTS: 4,
    CONFIGURATION: 5,
    OTHER_NEWS: 6
  }
};
